import React from "react";
import Navbar from "../components/Navbar/Index";
import { useOutletContext } from "react-router-dom";

function Blank() {
  const [sidebarToggle] = useOutletContext();
  return (
    <>
      <main className="h-full">
        <Navbar toggle={sidebarToggle} />


        {/* Main Content */}
        <div className="mainCard border-b-2 border-black">Blank Page
            <div className="flex flex-wrap">
            <div className=" sm:w-1/3 md:w-1/3 lg:w-1/3 p-4 text-center">
              <div className="pl-4 font-bold text-lg sm:text-base">TTC</div>
              <div className="pl-4 pt-1 font-bold text-gray-400 text-sm">Tech Titan Corp</div>
            </div>
            <div className=" sm:w-1/3 md:w-1/3 lg:w-1/3 p-4 text-center">
              <div className="pl-4 font-bold text-lg sm:text-base text-green-500">$112.5</div>
              <div className="pl-4 font-bold pt-1 text-green-500 text-sm">Tech Titan Corp</div>
            </div>
            <div className=" sm:w-1/3 md:w-1/3 lg:w-1/3 p-4 text-center">
              <div className="pl-4 font-bold text-lg sm:text-base">$112,450</div>
              <div className="pl-4 font-bold pt-1 text-gray-400 text-sm">1000 shares</div>
            </div>
        </div>    
</div>


        
      </main>
    </>
  );
}

export default Blank;
